// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3baPg","requiredAsterisk":"Info_requiredAsterisk__1PsSR"};